<template>
  <div class="mobile-inspecton-list">
    <div class="action-fixed-top">
      <div class="title">日常报修</div>
      <div class="df df-around vertical">
        <a-input v-model:value="requestPayload.serial" placeholder="请输入机身号" @change="handleUpdateSerial"
          style="width: 6rem" allowClear></a-input>

        <a-button size="small" type="primary" @click="handleAddData">新增</a-button>
      </div>
    </div>
    <!-- <a-button @click="handleScanCode">扫码</a-button>
    <div id="reader" width="600px"></div> -->

    <template v-for="item in tableData" :key="item.id">
      <div class="inspection">
        <div class="inspection-background df vertical both-side">
          <div>序号：{{ item.id }}</div>
        </div>
        <div class="form-item df vertical both-side">
          <div class="label">设备类型:</div>
          <div>{{ item.serialType }}</div>
        </div>
        <div class="form-item df vertical both-side">
          <div class="label">机身号:</div>
          <div>{{ item.serial }}</div>
        </div>
        <div class="form-item df vertical both-side">
          <div class="label">反馈时间:</div>
          <div>{{ item.produceDate }}</div>
        </div>

        <div class="form-item df vertical both-side">
          <div class="label">状态:</div>
          <div>{{ item.status }}</div>
        </div>

        <template v-for="(problem, problemIndex) in item.problemPhenomenon.split('#')" :key="problem">
          <div class="form-item df vertical both-side">
            <div class="label">反馈问题{{ problemIndex + 1 }}:</div>
            <div class="problem">{{ problem }}</div>
          </div>
        </template>


        <!-- <div class="form-item df vertical both-side">
          <div class="label">客户信息:</div>
          <div>{{ item.repairCustomerInfo }}</div>
        </div> -->
        <div class="df both-side vertical action">
          <!-- <a-button type="danger" @click="handleDelete(item)" :disabled="item.status === '已完成'">删除</a-button> -->
          <div></div>

          <a-button type="primary" @click="handleEditForm(item)" :disabled="item.status === '已完成'">
            查看详情
          </a-button>
        </div>
      </div>
    </template>

    <div class="pagination">
      <img src="@/assets/img/mobile/lease/prest.png" @click="handleUpdateList(1)" />
      <img src="@/assets/img/mobile/lease/pre.png" @click="handleUpdateList(requestPayload.pageNum - 1)" />
      <div class="size">
        {{ requestPayload.pageNum }}/{{
          Math.ceil(requestPayload.total / requestPayload.lineNum)
        }}
      </div>
      <img src="@/assets/img/mobile/lease/next.png" @click="handleUpdateList(requestPayload.pageNum + 1)" />
      <img src="@/assets/img/mobile/lease/nextest.png" @click="
        handleUpdateList(
          Math.ceil(requestPayload.total / requestPayload.lineNum)
        )
        " />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import {
  getAfterSaleRepairList,
  deleteAfterSaleRepair,
} from "@/request/view/afterSale.js";
import { debounce, Toast } from "@/utils/index";
import { showModal } from "@/views/repairprogress/serve/modal";
import { useRoute, useRouter } from "vue-router";
import ScanCode from '@/utils/base/scanCode';

export default defineComponent({
  setup() {
    // const scanCode = new ScanCode();
    const handleScanCode = () => {
      scanCode.getCameras();
    };

    const requestPayload = reactive({
      serial: null,
      lineNum: 10,
      pageNum: 1,
      serialType: null,
      total: 0,
    });

    const router = useRouter();
    const route = useRoute();

    const tableData = reactive([]);

    const selectSerial = ref([]);

    const options = [
      {
        value: "天鸽",
        label: "天鸽",
        children: [
          {
            value: "300",
            label: "300",
          },
          {
            value: "300S",
            label: "300S",
          },
        ],
      },
      {
        value: "天鹅",
        label: "天鹅",
        children: [
          {
            value: "600",
            label: "600",
          },
          {
            value: "600P",
            label: "600P",
          },
        ],
      },
    ];

    const getRepairData = () => {
      getAfterSaleRepairList({
        serial: requestPayload.serial,
        lineNum: requestPayload.lineNum,
        pageNum: requestPayload.pageNum,
        serialType: requestPayload.serialType,
        repairProcessType: requestPayload.repairProcessType,
        userId: requestPayload.userId,
      })
        .then((res) => {
          if (res.code === 200 && res.message === "成功") {
            tableData.length = 0;
            tableData.push(...res.data.records);
            requestPayload.total = res.data.total;
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleSerialChange = (e) => {
      if (selectSerial.value.length === 2) {
        const [machine, type] = e;
        requestPayload.serialType = `${machine}${type}`;
      } else {
        requestPayload.serialType = null;
      }
      requestPayload.pageNum = 1;
      getRepairData();
    };

    const handleUpdateSerial = debounce(() => {
      requestPayload.pageNum = 1;
      getRepairData();
    }, 100);

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteAfterSaleRepair([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getRepairData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleEditForm = (record) => {
      router.push({
        path: "/mobileaftersalerepairform",
        query: {
          type: "echo",
          data: JSON.stringify(record),
        },
      });
    };

    const handleAddData = () => {
      router.push({
        path: "/mobileaftersalerepairform",
        query: {
          type: "add",
        },
      });
    };

    // 页码更新
    const handleUpdateList = (page) => {
      let limtPage = null;
      const minPage = 1;
      const maxPage = Math.ceil(
        requestPayload.total / requestPayload.lineNum
      );
      if (page < minPage) {
        limtPage = 1;
        return Toast("warning", "首页", 3);
      } else if (page > maxPage) {
        limtPage = maxPage;
        return Toast("warning", "尾页", 3);
      } else {
        limtPage = page;
      }
      requestPayload.pageNum = limtPage;
      getRepairData();
    };

    watch(
      () => route,
      (val) => {
        const isUpdate = localStorage.getItem("QC_QC_update") == 1;
        if (val.path === "/mobileaftersalerepair" && isUpdate) {
          localStorage.removeItem('QC_QC_update');
          getRepairData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    getRepairData();

    return {
      options,
      tableData,
      selectSerial,
      requestPayload,
      handleScanCode,
      handleUpdateList,
      handleAddData,
      handleDelete,
      handleEditForm,
      handleSerialChange,
      handleUpdateSerial,
    };
  },
});
</script>

<style lang="less" scoped>
.mobile-inspecton-list {
    padding: 2.3rem 0.2rem 0;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background: #f3f5f6;

    .action-fixed-top {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        padding: 0.3rem 0.2rem;
        background: #fff;
        z-index: 99;
        .title {
            font-size: 0.4rem;
            text-align: center;
            font-weight: bold;
            margin-bottom: 0.3rem;
        }
    }

    .inspection-button {
        width: 2.03rem;
        height: 0.91rem;
        background: #ffffff;
        box-shadow: 0rem 0.01rem 0.07rem 0rem rgba(38, 38, 38, 0.1),
            0rem 0.08rem 0.24rem 0.01rem rgba(38, 38, 38, 0.14);
        border-radius: 0.45rem;
        font-size: 0.43rem;
        font-weight: bold;
        color: #23c1b2;
        line-height: 0.91rem;
        text-align: center;
    }

    .inspection {
        margin-top: 0.6rem;
        background: #fff;
        padding-bottom: 0.32rem;
        background: #ffffff;
        box-shadow: 0rem 0.01rem 0.07rem 0rem rgba(38, 38, 38, 0.1),
            0rem 0.08rem 0.24rem 0.01rem rgba(38, 38, 38, 0.14);
        border-radius: 0.27rem;

        .inspection-background {
            // background: url("../../../../../../assets/img/mobile/page/inspectionbackground.png");
            background: url("../../../assets/img/mobile/page/inspectionbackground.png");
            background-size: 100% 100%;
            width: 9.6rem;
            height: 1.07rem;
            line-height: 1.07rem;
            font-size: 0.37rem;
            color: #ffffff;
            padding-left: 0.6rem;
            padding-right: 0.32rem;
        }

        .action {
            width: 9.07rem;
            margin: 0.32rem 0.27rem 0;
            padding: 0.24rem 0.1rem 0.24rem 0.32rem;
        }

        .form-item {
            width: 9.07rem;
            background: #ffffff;
            border-radius: 0.16rem;
            border: 0.03rem solid #d9dce4;
            margin: 0.32rem 0.27rem 0;
            padding: 0.24rem 0.4rem 0.24rem 0.32rem;
            font-size: 0.37rem;
        }

        .inspection-level {
            width: 1.43rem;
            height: 0.75rem;
            border-radius: 0.27rem;
            font-size: 0.43rem;
            font-weight: bold;
            color: #ffffff;
            line-height: 0.75rem;
            text-align: center;
        }

        .inspection-level-1 {
            background: linear-gradient(132deg, #25f4d3 0%, #28bfde 100%);
        }

        .inspection-level-2 {
            background: linear-gradient(132deg, #fae662 0%, #fed74c 100%);
        }

        .inspection-level-3 {
            background: linear-gradient(132deg, #febf11 0%, #fea50d 100%);
        }

        .inspection-level-4 {
            background: linear-gradient(132deg, #ffa54f 0%, #fc754c 100%);
        }

        .inspection-level-5 {
            background: linear-gradient(132deg, #ff9655 0%, #ff0000 100%);
        }

        .look-button {
            width: 2.29rem;
            height: 0.72rem;
            border-radius: 0.35rem;
            border: 0.03rem solid #d9dce4;
            text-align: center;
            line-height: 0.72rem;
            font-size: 0.35rem;
            color: #35b7ad;
            margin: 0.32rem 0.32rem 0 0;
        }
    }
}

.mobile-inspecton-list {
  padding: 2.3rem 0.2rem 1.6rem;
}

.problem {
  width: 6rem;
  text-align: right;
}

.pagination {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.2rem 0.84rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;

  img {
    width: 0.85rem;
    height: 0.85rem;
    display: block;
  }

  .size {
    width: 3.07rem;
    height: 0.91rem;
    text-align: center;
    line-height: 0.8rem;
    border: 0.07rem solid #143022;
    border-radius: 0.24rem;
    font-size: 0.37rem;
    color: #202020;
  }
}
</style>
